import { render, staticRenderFns } from "./CreditorsManager.vue?vue&type=template&id=44843303&scoped=true"
import script from "./CreditorsManager.vue?vue&type=script&lang=js"
export * from "./CreditorsManager.vue?vue&type=script&lang=js"
import style0 from "./CreditorsManager.vue?vue&type=style&index=0&id=44843303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44843303",
  null
  
)

export default component.exports